<template>
  <div>
    <section class="content-header">
      <h1>My Packages</h1>
    </section>

    <section class="content">
      <div class="row">
        <div class="col-lg-12 col-12">
          <div class="cyber-table-box">
            <div class="cyber-table-box__glow"></div>
            <div class="cyber-table-box__header">
              <i class="mdi mdi-package-variant-closed"></i>
              <h4>Packs Detail</h4>
            </div>
            <div class="cyber-table-box__body">
              <div class="table-responsive">
                <table class="table table-bordered no-margin">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Pack</th>
                      <th class="text-center">Status</th>
                      <th class="text-right">Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in tableData" :key="index">
                      <td class="text-left">
                        <span class="cyber-id">{{ item.id }}</span>
                      </td>
                      <td class="text-left">{{ item.plan.name }}</td>
                      <td class="text-center">
                        <span
                          class="badge"
                          :class="{
                            'badge-success': item.subscription_status === 'active',
                            'badge-danger': item.subscription_status === 'expired',
                            'badge-warning': item.subscription_status === 'cancelled'
                          }"
                        >
                          {{ item.subscription_status === "active" ? "Active" :
                             item.subscription_status === "expired" ? "Ended" : "Canceled" }}
                        </span>
                      </td>
                      <td class="text-right">
                        <span class="cyber-date">{{ item.created_at | formatDate("MMMM Do YYYY") }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>
.cyber-table-box {
  background: #252525;
  border: 1px solid #3d3d37;
  border-radius: 14px;
  overflow: hidden;
  position: relative;
}

.cyber-table-box__glow {
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(176, 154, 78, 0.3), transparent);
}

.cyber-table-box__header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 18px 20px;
  border-bottom: 1px solid #3d3d37;
}

.cyber-table-box__header i {
  color: #B09A4E;
  font-size: 1.2rem;
}

.cyber-table-box__header h4 {
  font-family: 'Orbitron', sans-serif !important;
  font-size: 0.8rem !important;
  color: #E0DFD8 !important;
  margin: 0 !important;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.cyber-table-box__body {
  padding: 0;
}

.cyber-id {
  color: #B09A4E;
  font-weight: 600;
}

.cyber-date {
  color: #9A998F;
  font-size: 0.8rem;
}
</style>

<script>
import { formatDollar, formatDate } from "@/filters";

export default {
  name: "subcriptions",
  props: {
    title: String,
  },
  data() {
    return {
      type: "dark",
      loading: false,
      tableData: [],
      last_subs: {},
    };
  },
  filters: { formatDollar, formatDate },
  created() {
    this.last_subs = this.$store.getters.currentUser.last_subs;
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      this.$http
        .get("/api/v1/client/subscriptions", {
          headers: {
            "content-type": "application/json",
            Authorization: this.$store.getters.authToken,
          },
        })
        .then((response) => {
          this.loading = false;
          this.tableData = response.data;
        })
        .catch((error) => {
          error.response.data &&
            error.response.data.map((m) => {
              this.$toasted.show(m, {
                position: "top-right",
                duration: 5000,
                type: "error",
                closeOnSwipe: true,
              });
            });
          this.loading = false;
        });
    },
  },
};
</script>
